import { trpc } from '@/shared/api';

/** HOME 함께한 기업 로고 목록 캐시 무효화 함수를 돌려준다. */
export const useInvalidateLandingPartners = (): (() => void) => {
  const utils = trpc.useUtils();

  return () => void utils.landing.listPartnersAdmin.invalidate();
};
